import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import LockIcon from "@mui/icons-material/Lock";
import VisibilityIcon from "@mui/icons-material/Visibility";

interface UserActionMenuProps {
  row: any;
  handleEdit: (data: any) => void;
  handleUpdatePassword?: (data: any) => void;
  handleViewDetails?: (data: any) => void;
  canEdit: boolean;
}

export const UserActionMenu = ({
  row,
  handleEdit,
  handleUpdatePassword,
  handleViewDetails,
  canEdit,
}: UserActionMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <button
        onClick={handleClick}
        style={{
          background: "none",
          border: "none",
          padding: 0,
          cursor: "pointer",
        }}
      >
        <i className="bi bi-three-dots-vertical fs-5 text-dark"></i>
      </button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          elevation: 3,
          sx: {
            fontFamily: "var(--bs-font-sans-serif) !important",
            "& *": {
              fontFamily: "var(--bs-font-sans-serif) !important",
            },
            "& .MuiMenuItem-root": {
              minHeight: "28px",
              padding: "4px 12px",
            },
            "& .MuiMenuItem-root .MuiListItemText-primary": {
              fontSize: "13px !important",
              fontWeight: "500 !important",
            },
          },
        }}
      >
        {canEdit && (
          <MenuItem
            onClick={() => {
              handleEdit(row.original);
              handleClose();
            }}
          >
            <ListItemIcon>
              <EditIcon fontSize="small" color="primary" />
            </ListItemIcon>
            {/* <ListItemText primary="Edit" sx={{ color: "primary.main" }} /> */}
            <ListItemText primary="Edit" />
          </MenuItem>
        )}

        {canEdit && handleUpdatePassword && (
          <MenuItem
            onClick={() => {
              handleUpdatePassword?.(row.original);
              handleClose();
            }}
          >
            <ListItemIcon>
              <LockIcon fontSize="small" color="primary" />
            </ListItemIcon>
            <ListItemText primary="Update Password" />
          </MenuItem>
        )}

        {handleViewDetails && (
          <MenuItem
            onClick={() => {
              handleViewDetails(row.original);
              handleClose();
            }}
          >
            <ListItemIcon>
              <VisibilityIcon fontSize="small" color="primary" />
            </ListItemIcon>
            <ListItemText primary="View Details" />
          </MenuItem>
        )}
      </Menu>
    </>
  );
};
